/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../config';

const Meta = (props) => {
    return (
        <Helmet>
            {props.tags && props.tags.length && props.tags.map((tag, i) => {
                return (
                    React.createElement(tag.name, { key: `tag${i}` }, tag.content)
                );
            })}
            {props.metaTags && props.metaTags.length && props.metaTags.map((metaTag, i) => {
                if (metaTag.name && metaTag.property) {
                    return [
                        <meta name={metaTag.name} content={metaTag.content} key={`metaName${i}`} />,
                        <meta property={metaTag.property} content={metaTag.content} key={`metaProperty${i}`} />,
                    ];
                }
                if (metaTag.name) {
                    return (
                        <meta name={metaTag.name} content={metaTag.content} key={`metaName${i}`} />
                    );
                }
                if (metaTag.property) {
                    return (
                        <meta property={metaTag.property} content={metaTag.content} key={`metaProperty${i}`} />
                    );
                }
            })}
        </Helmet>
    );
};

const Head = (props) => {
    return (
        <Meta
            tags={[
                { name: 'title', content: (props.title || 'Universal Tennis - Unifying tennis for everyone') },
            ]}
            metaTags={[
                { name: 'description', content: (props.description || 'UTR is a rating system that provides a single, unifying language and standard for tennis players across ages, geography, gender and economics.') },
                { name: 'keywords', content: (props.keywords || '') },
                { property: 'og:type', content: 'website' },
                { property: 'og:title', content: (props.title || 'Universal Tennis - Unifying tennis for everyone') },
                { property: 'og:description', content: (props.description || 'UTR is a rating system that provides a single, unifying language and standard for tennis players across ages, geography, gender and economics.') },
                { property: 'og:image', content: (props.image || `https://www.${config.siteBaseUrl}/img/v2/ut-logo2.svg`) },
                { property: 'og:url', content: (props.url || `https://${config.siteBaseUrl}`) },
                { property: 'og:image:width', content: (props.imageWidth || '930') },
                { property: 'og:image:height', content: (props.imageHeight || '395') },
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:site', content: '@MyUTR' },
                { name: 'twitter:creator', content: '@MyUTR' },
                { name: 'twitter:url', content: (props.url || `https://${config.siteBaseUrl}`) },
                { name: 'twitter:title', content: (props.title || 'Universal Tennis - Unifying tennis for everyone') },
                { name: 'twitter:description', content: (props.description || 'UTR is a rating system that provides a single, unifying language and standard for tennis players across ages, geography, gender and economics.') },
                { name: 'twitter:image', content: (props.image || `https://www.${config.siteBaseUrl}/img/v2/ut-logo2.svg`) },
            ]}
        />
    );
};

export default Head;
